import React, { useCallback } from "react";
import { useDeviceTypes } from "halifax";
import { getConfigTenant, isVesperTenant } from "@capone/common";
import { useHtsCfarExerciseModal } from "../../../../../../features/cancel-for-any-reason/hooks/useHtsCfarExerciseModal";

type HtsCfarExerciseModalProps = {
  exerciseUrl: string;
  cfarVerticalLoadingScreen: JSX.Element;
  setDisableOnClose: (disableOnClose: boolean) => void;
  setHideXButton: (hideXButton: boolean) => void;
  onClose: () => void;
  onReady?: () => void;
  onClickCancel?: () => void;
  onClickConfirm?: () => void;
  onExerciseSuccess?: () => void;
};

export const HtsCfarExerciseModal: React.FC<HtsCfarExerciseModalProps> = ({
  exerciseUrl,
  cfarVerticalLoadingScreen,
  setHideXButton,
  setDisableOnClose,
  onClose,
  onReady,
  onClickCancel,
  onClickConfirm,
  onExerciseSuccess,
}) => {
  const { matchesMobile } = useDeviceTypes();
  const isVesper = isVesperTenant(getConfigTenant());
  const iframeUrl = isVesper
    ? `${exerciseUrl}${exerciseUrl.includes("?") ? "&" : "?"}uiTheme=premium`
    : exerciseUrl;

  const enableClose = useCallback(() => {
    setDisableOnClose(false);
    setHideXButton(false);
  }, [setDisableOnClose, setHideXButton]);

  const disableClose = useCallback(() => {
    setDisableOnClose(true);
    setHideXButton(true);
  }, [setDisableOnClose, setHideXButton]);

  const { isLoading, iframeHeight } = useHtsCfarExerciseModal({
    onClose,
    enableClose,
    disableClose,
    onReady,
    onClickCancel,
    onClickConfirm,
    onExerciseSuccess,
  });

  return (
    <>
      {isLoading && cfarVerticalLoadingScreen}
      <div
        style={{
          display: isLoading ? "none" : "block",
          padding: matchesMobile ? "50px 16px 30px" : "55px 30px 30px",
          boxSizing: "border-box",
        }}
      >
        <iframe
          style={{
            boxSizing: "border-box",
            width: "100%",
            height: `${iframeHeight}px`,
            border: "none",
          }}
          src={iframeUrl}
          title="Cancel for Any Reason Exercise"
        />
      </div>
    </>
  );
};
